import "@adeccoux/tag-ds/index.css";
import { useState, useRef, useEffect, createContext } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Base from "./components/base";
import "./components/main.css";
import WelcomeScreen from "./components/TTWelcome Screen/welcomeScreen";
import InformationScreen from "./components/TTWelcome Screen/informationScreen";
import { CommonPopup, TestErrorPopup } from "./util/common";
import Instructions from "./components/instructions/instructions";
import Demographics from "./components/instructions/demographics";
import TestTaker from "./components/TT82/TestTaker";
import TestTaker28 from "./components/TT28/testTaker28";
import LanguageTests from "./components/languageTests/languageTestTaker";
import AudioTest from "./components/languageTests/audioTest";
import SysCheck from "./components/TTWelcome Screen/sysCheck";
import TypingTests from "./components/typingTests/TypingTestTaker";
import TestTaker21 from "./components/TT21/TestTaker21";
import TestTaker24 from "./components/TT24/TestTaker24";
import SimpleTest from "./components/Teamplate/SimpleQuestion";
import TestTaker32 from "./components/TT32/TestTaker32";
import SimpleQuestion from "./components/TT36/SimpleQuestion";
import SurveyQues from "./components/surveys/surveyQues";
import TestTaker70 from "./components/TT70/TestTaker70";
import Scorm from "./components/scorm/scorm";
import TestTakerForFM from "./components/TT37/TestTakerForFM";
import AssessmentSummary from "../../testtakerRedesign/src/components/Teamplate/summaryInterstitial";

export const BaseContext = createContext();

function App() {
    const [phrases, setPhrases] = useState();
    const [loading, setLocalLoading] = useState(false);
    const [isQuesError, setQuesError] = useState(false);
    const [isWarmupDoneShown, setWarmupDoneShown] = useState(false);
    const [RCLaunched, setRCLaunched] = useState(false);
    const [selectedLang, setSelectedLang] = useState("DFL");
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });

    const testPreviewOpened = useRef(false);
    const location = useLocation();
    const delayTime = useRef(300);
    const delayInterval = useRef();
    const navigate = useNavigate();

    const toShowAnimation =
        location.state?.test &&
        location.pathname !== "/instructions" &&
        location.pathname !== "/demographics" &&
        location.pathname !== "/surveyInstructions" &&
        location.pathname !== "/sysCheck" &&
        location.pathname !== "/sysCheck" &&
        location.pathname !== "/audioTest";

    const preventFunc = (e, type) => {
        e.preventDefault();
        setpopupData((prev) => {
            prev = {
                ...prev,
                isOpen: true,
                popupBody: type === 1 ? phrases?.["10"] : phrases?.["1000205"],
                popupFooter: phrases?.["10928"],
            };
            return prev;
        });
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const detectKeyDown = (event) => {
        if ((event.ctrlKey || event.metaKey) && event.code === "KeyQ") {
            window.opener.location.href =
                "/indexpart/applicantssessions/applicantList";
            window.close();
        }
    };

    const setLoading = (val) => {
        if (val) {
            setLocalLoading(true);
            delayInterval.current = setInterval(() => {
                delayTime.current -= 1;
            }, 1);
        } else {
            let delayDebounceFn = setTimeout(() => {
                setLocalLoading(false);
                clearInterval(delayInterval.current);
                delayTime.current = 300;
            }, delayTime.current);
        }
    };

    const closeQuesError = () => {
        setQuesError(false);
        navigate("/");
    };

    useEffect(() => {
        const listener = document.addEventListener("keydown", detectKeyDown);
        return () => document.removeEventListener("keydown", listener);
    }, []);

    return (
        <div
            className={`tag-ds agnostic stop-select notranslate ${!toShowAnimation
                ? loading
                    ? "contentLeave"
                    : "contentEnter"
                : ""
                }`}
            onCopy={(e) => preventFunc(e, 1)}
            onCut={(e) => preventFunc(e, 1)}
            onPaste={(e) => preventFunc(e, 1)}
            onContextMenu={(e) => preventFunc(e, 2)}
            translate="no"
        >
            {isQuesError && <TestErrorPopup closeAction={closeQuesError} />}
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                setterFun={setpopupData}
            />
            <Base>
                <BaseContext.Provider
                    value={{
                        loading,
                        setLoading,
                        setQuesError,
                        isWarmupDoneShown,
                        setWarmupDoneShown,
                    }}
                >
                    <main role="main" className="bg02 p2 main-xpert-container">
                        <div className="g-container flex_col p4 py3_tablet px5_tablet pt0_mobile g5 g2_mobile  sub-container-main roundness_1 align-items_start justify-content_center">
                            <Routes>
                                <Route
                                    path="/"
                                    element={
                                        <WelcomeScreen
                                            setAppPhrases={setPhrases}
                                            testPreviewOpened={testPreviewOpened}
                                            RCLaunched={RCLaunched}
                                            setRCLaunched={setRCLaunched}
                                            setSelectedLang={setSelectedLang}
                                        />
                                    }
                                />
                                <Route
                                    path="/sysCheck"
                                    element={
                                        <SysCheck selectedLang={selectedLang} />
                                    }
                                />
                                <Route
                                    path="/surveyInstructions"
                                    element={
                                        <InformationScreen type="surveyInstructions" />
                                    }
                                />
                                <Route
                                    path="/demographics"
                                    element={<Demographics />}
                                />
                                <Route
                                    path="/instructions"
                                    element={<Instructions />}
                                />
                                <Route path="/TT82" element={<TestTaker />} />
                                <Route path="/TT28" element={<TestTaker28 />} />
                                <Route
                                    path="/langTest"
                                    element={<LanguageTests />}
                                />
                                <Route path="/audioTest" element={<AudioTest />} />
                                <Route
                                    path="/typingTest"
                                    element={<TypingTests />}
                                />
                                <Route path="/TT21" element={<TestTaker21 />} />
                                <Route path="/TT24" element={<TestTaker24 />} />
                                <Route
                                    path="/simpleTest"
                                    element={<SimpleTest />}
                                />
                                <Route path="/TT32" element={<TestTaker32 />} />
                                <Route path="/TT36" element={<SimpleQuestion />} />
                                <Route path="/survey" element={<SurveyQues />} />
                                <Route path="/TT70" element={<TestTaker70 />} />
                                <Route path="/scorm" element={<Scorm />} />
                                <Route path="/TT37" element={<TestTakerForFM />} />
                                <Route
                                    path="/assessmentSummary"
                                    element={
                                        <AssessmentSummary
                                        />
                                    }
                                />
                            </Routes>
                        </div>
                    </main>
                </BaseContext.Provider>
            </Base>
        </div>
    );
}
export default App;
